// src/components/ErrorBoundary.js
// Catches render errors in child components and shows a fallback UI
// instead of crashing the entire page.

import React from 'react';
import { Box, Typography } from '@mui/material';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('[LFBBQ] Component error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <Box
          sx={{
            py: 4,
            textAlign: 'center',
          }}
        >
          <Typography
            sx={{
              fontFamily: 'Roboto, sans-serif',
              color: 'rgba(0,0,0,0.4)',
              fontSize: '14px',
            }}
          >
            {this.props.fallbackMessage || 'Something went wrong loading this section.'}
          </Typography>
        </Box>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
